export const CATALOGUE_PATH = '/avatar-catalogue'
export const PUBLISH_PATH = '/avatar-catalogue/publish'
export const TIERS_PATH = '/avatar-catalogue/tiers'
export const IMAGE_SIZES_PATH = '/avatar-catalogue/image-sizes'
